
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faRedo,
} from '@fortawesome/free-solid-svg-icons';

export default function ResetSurveyButton({ loadStaticSurvey, hudResetUrl }) {

    const handleClick = () => {
        loadStaticSurvey(hudResetUrl);
    };

    return (
        <button
            onClick={handleClick}
            className="position-fixed d-flex align-items-center reset-survey-btn"
            style={{
                backgroundColor: 'white',
                padding: '10px 15px',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                zIndex: 1000,
                border: '2px solid transparent',
                cursor: 'pointer',
                transition: 'border-color 0.2s',
                gap: '8px',
                fontSize: '0.8rem',
                fontWeight: 'bold'
            }}
            onMouseOver={(e) => e.currentTarget.style.borderColor = '#FFA500'}
            onMouseOut={(e) => e.currentTarget.style.borderColor = 'transparent'}
        >
            <FontAwesomeIcon className="px-1" fw="true" flip="horizontal" icon={faRedo} />
            <span className="d-none d-md-inline">Relancer une enquête</span>
        </button>



    );
}